module.exports = "<div class=\"grid-x\">\n    <div class=\"cell medium-1 large-3\"></div>\n    <div class=\"cell medium-10 large-6\">\n        <guest-edit></guest-edit>\n    </div>\n    <div class=\"cell medium-1 large-3\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/guest/views/guest.page.html
// module id = 716
// module chunks = 0